import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=a1443a96&scoped=true"
import script from "./CurrencySelect.vue?vue&type=script&lang=js"
export * from "./CurrencySelect.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelect.vue?vue&type=style&index=0&id=a1443a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1443a96",
  null
  
)

export default component.exports